import React, {useState} from 'react';
import {Button, Input, message, Modal, Space, Steps} from 'antd';
import {Auth} from "aws-amplify";
import {useHistory} from "react-router-dom";

const {Step} = Steps;

const ForgotPassword = (props) => {
    const [isModalVisible, setIsModalVisible] = useState(props.reset);
    const [userName, setUserName] = useState('');
    const [currentStep, setCurrentStep] = useState(props.step ? props.step : 0);
    const [code, setCode] = useState(props.code);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const history = useHistory();

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        if (currentStep === 0) {
            if (userName === '') {
                message.warning("Please enter your email!");
            } else {
                Auth.forgotPassword(userName).then((res) => {
                        setCurrentStep(1);
                    }
                ).catch((err) => {
                    message.error(err.message);
                });
            }
        } else if (currentStep === 1 || currentStep === "1") {
            if (userName === '') {
                message.warning("Please enter your email!");
            }
            else if (code === '') {
                message.warning("Please enter code!");
            } else if (password === '' || confirmPassword === '' || password !== confirmPassword) {
                message.warning("Passwords don't match!");
            } else {
                Auth.forgotPasswordSubmit(
                    userName,
                    code,
                    password
                ).then((res) => {
                    message.success("Password reset successfully.");
                    history.push("/login");
                    setIsModalVisible(false);
                }).catch((err) => {
                    message.error(err.message);
                });
            }
        }

    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <>

            <Button size="small" type="link" onClick={showModal}>
                Forgot Password?
            </Button>
            <Modal title="Password Recovery" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
                <Steps current={currentStep}>
                    <Step title="Get code"/>
                    <Step title="Reset Password"/>
                </Steps>
                {currentStep === 0 && (
                    <div style={{marginTop: 20}}>
                        <Input placeholder="Enter your email to get a reset code" value={userName}
                               onChange={(e) => setUserName(e.target.value)}/>
                    </div>
                )}
                {currentStep === 1 && (
                    <div style={{marginTop: 20}}>
                        <Space direction="vertical" style={{width: '100%'}}>
                            <Input placeholder="Enter your email" value={userName}
                                   onChange={(e) => setUserName(e.target.value)}/>
                            <Input placeholder="Enter code received in your email" value={code}
                                   onChange={(e) => setCode(e.target.value)}/>
                            <Input.Password placeholder="New Password" value={password}
                                            onChange={(e) => setPassword(e.target.value)}/>
                            <Input.Password placeholder="Confirm Password" value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}/>
                        </Space>

                    </div>
                )}

            </Modal>
        </>
    );
};

export default ForgotPassword;